import * as React from 'react'
import { useLocation } from 'react-router-dom'

/**
 * The company the user is currently looking at, taken from the URL.
 *
 * Modern routes carry `/company/:companyId/...` and are the reliable source; the
 * legacy redux `companySelection` is populated only on some paths, which is why
 * task tracking keyed on it silently did nothing on most screens.
 *
 * Must be a real UUID. The old `[0-9a-fA-F-]{36}` class also matched 36-character
 * junk, and `/importTask/active` then 404'd in `resolveImportCompany`.
 */
const COMPANY_UUID_IN_PATH =
  /\/company\/([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})(?:\/|$)/

export const companyIdFromPath = (pathname: string): string | null => {
  const match = COMPANY_UUID_IN_PATH.exec(pathname)
  return match ? match[1] : null
}

export const useRouteCompanyId = (): string | null => {
  const location = useLocation()
  return React.useMemo(
    () => companyIdFromPath(location.pathname),
    [location.pathname],
  )
}
